import "./color.scss";

import * as React from "react";

export const Colors = ({colorsTileConfig}) => ({
    label: "Colors",
    render: () => <div className="vertical-colors-6kl">{colorsTileConfig?.render()}</div>,
});
